import React, { useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/globals.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomeSection from './components/HomeSection/HomeSection';
import Banner from './components/Banner/Banner';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/shared/ScrollToTop/ScrollToTop';
import { CanvasProvider } from './context/CanvasContext';
import { LoaderProvider } from './context/LoaderContext';
import Loader from './components/Loader/Loader';
import { initFacebookPixel } from './utils/facebook-pixel';
import { initGoogleAnalytics } from './utils/google-analytics';
import CookieConsent from './components/shared/CookieConsent/CookieConsent';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { LanguageProvider } from './context/LanguageContext';

const App: React.FC = () => {
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '';

  useEffect(() => {
    // Initialize tracking
    initFacebookPixel();
    initGoogleAnalytics();
  }, []);

  return (
    <LoaderProvider>
      <LanguageProvider>
        <CanvasProvider>
          <div className="page-container">
            <CookieConsent />
            <ScrollToTop />
            <Loader />
            <Banner showMainContent={isHome} />
            <main className={`main-content ${!isHome ? 'content-offset' : ''}`}>
              <Routes>
                <Route path="" element={<HomeSection />} />
                <Route path="/" element={<HomeSection />} />
                <Route path="/contacto" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="*" element={<HomeSection />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </CanvasProvider>
      </LanguageProvider>
    </LoaderProvider>
  );
}

export default App;

